import { __exports as r } from "../../../../../../../../_virtual/sanitizer2.js";
import "../../../../../../@braintree_sanitize-url@7.0.2/bundled_deps/@braintree/sanitize-url/dist/index.js";
import { __exports as t } from "../../../../../../../../_virtual/index3.js";
Object.defineProperty(r, "__esModule", {
  value: !0
});
r.sanitizeUrl = s;
var i = t;
function s(e) {
  return e && (0, i.sanitizeUrl)(e);
}
export {
  r as default
};
